import BaseButtonList from "./BaseButtonList.vue";

export * from "./BaseButtonList.vue";
export default BaseButtonList;
